(function ($) {
  var videoWithProductsSliderV1 = {
  };

  Drupal.behaviors.videoWithProductsSliderV1 = {
    get: function (key) {
      return videoWithProductsSliderV1[key];
    },

    set: function (key, val) {
      videoWithProductsSliderV1[key] = val;
    },

    attach: function (context, settings) {
      $('.add-all-to-bag.button', context).on('click', function(e) {
        e.preventDefault();
        // iterate through each product div to get sku for 'add all to cart'
        var buySkus = [];

        $(this).parents('.products-sidebar:first').find('.product[data-productid]').each(function () {
          buySkus.push(Drupal.behaviors.ctaButton.actions.getSkuId($(this)));
        });
        // add sku array to cart
        site.addToCart({
          skuBaseId: buySkus
        });
      });
    }
  };
})(jQuery);
